<template>
    
    <span>
        
        <v-dialog v-model="tagExport"
        width="400"
        persistent
        >

            <template v-slot:activator="{ on }">

                <v-btn 
                v-on="on"
                text
                @click="downloadData(selectedTag)">
                    <v-icon class="mr-3">mdi-cloud-download</v-icon>
                    <span>{{ $t("Download data") }}</span>
                </v-btn>

            </template>

            <v-card v-if="!downloading">

                <v-card-title>{{ $t("Export tag data") }}</v-card-title>
                
                <v-divider></v-divider>

                <v-card-text class="pa-4 pb-0">

                    <v-row>

                        <v-col>

                            <v-menu
                                ref="fromMenu"
                                v-model="fromMenu"
                                :close-on-content-click="false"
                                :return-value.sync="fromDate"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">

                                    <v-text-field
                                        v-model="fromDate"
                                        :label="$t('From')"
                                        readonly
                                        v-on="on"
                                        outlined
                                        reactive
                                        hide-details
                                    ></v-text-field>

                                </template>

                                <v-date-picker 
                                    v-model="fromDate" 
                                    no-title 
                                    @input="$refs.fromMenu.save(fromDate)"
                                    @change="setTillDate()">
                                </v-date-picker>

                            </v-menu>

                        </v-col>

                        <v-col>

                            <v-menu
                                ref="toMenu"
                                v-model="toMenu"
                                :close-on-content-click="false"
                                :return-value.sync="tillDate"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="tillDate"
                                    :label="$t('Till')"
                                    readonly
                                    v-on="on"
                                    outlined
                                    reactive
                                    hide-details
                                ></v-text-field>
                                </template>
                                <v-date-picker 
                                    v-model="tillDate" 
                                    no-title 
                                    @input="$refs.toMenu.save(tillDate)">
                                    <!-- @change="getLoggingData()" -->
                                </v-date-picker>
                            </v-menu>

                        </v-col>

                    </v-row>

                    <v-select
                        v-model="exportType"
                        :items="exportTypes"
                        :label="$t('Select export type')"
                        item-text="text"
                        item-value="value"
                        outlined
                        return-object
                        close-on-select                    
                    ></v-select>

                </v-card-text>

                <v-card-actions color="grey" class="pb-4 pt-4">

                    <v-btn depressed class="mx-2" color="primary" @click="download();">{{ $t("Export") }}</v-btn>
                    <v-btn outlined class="mx-2" @click="tagExport = false">{{ $t("Cancel") }}</v-btn>

                </v-card-actions>

            </v-card>

            <v-card v-if="downloading">

                <v-card-title> {{ $t("Exporting") }} </v-card-title>
                
                <v-divider></v-divider>

                <v-card-text align="center" class="pt-4">

                    <v-progress-circular
                    :rotate="-90"
                    :size="100"
                    :width="15"
                    :value="percentageDone"
                    color="primary"
                    >
                    {{ percentageDone }}%
                    </v-progress-circular>
                
                </v-card-text>
                
                <v-card-actions color="grey" class="pb-4 pt-4">

                    <JsonExcel
                        class   = "btn btn-default"
                        :data = "exportData"
                        :fields = "excel_columns"
                        worksheet = "Data"
                        name    = "DataExport.xls"
                        :type = exportType
                        v-if="!hideDownloadButton">
                        
                        <v-btn
                            depressed class="mx-2" color="primary"
                        >
                            {{ $t("Download") }}
                        </v-btn>
                    
                    </JsonExcel>

                    <v-btn
                        outlined class="mx-2"
                        @click="downloading = false"
                    >
                        {{ $t("Cancel") }}
                    </v-btn>
                
                </v-card-actions>

            </v-card>

        </v-dialog>

    </span>

</template>

<script>

// import firebase from "firebase";

import { mapGetters } from "vuex";
import moment from "moment";
import JsonExcel from 'vue-json-excel';


export default {

    computed: {

        ...mapGetters({
            app: 'app/data',
            selected: 'app/selected',
            exportTag: 'app/exportTag',
        })

    },

    data () {
        return {
            fromDate: null,
            tillDate: null,
            toMenu: false,
            fromMenu: false,
            addPopup: false,
            tagExport: false,
            TagId: null,
            exportTypes: [
                { text: 'CSV', value: 'csv' },
                { text: 'Excel (XLS)', value: 'xls' },
                // { text: 'XML', value: 'xml' },
            ],
            exportType: null,
            exportData: [],
            exportFromDate: null,
            exportTillDate: null,
            exportFinished : false,
            dayCounter : null,
            nrOfdays : null,
            percentageDone : null,
            hideDownloadButton : true,
            downloading:false,

            excel_columns: {
                'Tag id': 'tag_id',
                'Log id' : 'id',
                'name': 'name',
                'Date and time': 'datetime',
                'Value' : 'value',
                
            },
            excel_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ]
        }
    },

    components: {
        JsonExcel,
    },
    props:{
        selectedTag: {
            type: Object,
            required: true,
        },
    },
    methods: {

        download(){
            
            this.downloading = true ;
            this.exportData = [];

            this.dayCounter = 0;

            this.hideDownloadButton = true;

            let start_moment = moment(this.fromDate);
            let end_moment = moment(this.tillDate);

            this.nrOfdays = Math.abs(start_moment.diff(end_moment, "days"));

            this.getLoggingData();

        },

        getLoggingData(){

            if(this.exportTag && this.exportType){

                this.exportFromDate = moment(this.fromDate).add(this.dayCounter, "days");
                this.exportTillDate = moment(this.fromDate).add(this.dayCounter + 1, "days");
                
                this.percentageDone = Math.round((this.dayCounter +1)/(this.nrOfdays ) * 100) ;

                this.getFirebaseTagData(this.exportTag ,()=>{
                    if(this.dayCounter == (this.nrOfdays - 1)){
                        this.hideDownloadButton = false;
                        // finished
                    }else{
                        this.dayCounter = this.dayCounter +1;
                        this.getLoggingData();
                    }
                });               

            }      

        },

        getFirebaseTagData(tag, callback){

            //Get tags

            let timestamp_from = this.exportFromDate.unix(); 
            let timestamp_till = this.exportTillDate.unix(); 

            //let tagData = [];
            var logReference = tag.reporter.db.collection('logs');

            logReference
            .where("tag_id", "==", tag.id)
            .where("datetime", ">=", timestamp_from)
            .where("datetime", "<=", timestamp_till)
            .orderBy("datetime", "desc")
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((logTag) => {
                    
                    let dataToStore = logTag.data();
                    dataToStore.name = tag.name;
                    dataToStore.id = logTag.id;
                    this.set_Tag(dataToStore);

                });
               
                callback();
            })
            .catch(function(error) {
                console.log(error);
            });

        },

        set_Tag(loggingTag){

            var log_data = {};
            log_data.tag_id = loggingTag.tag_id;
            log_data.id = loggingTag.id;
            log_data.name = loggingTag.name;
            log_data.datetime = moment.unix(loggingTag.datetime).format("YYYY-MM-DD HH:mm:ss");
            log_data.value = loggingTag.value;
            this.exportData.push(log_data) ;

        },

        setTillDate(){

            let newDate = moment(this.fromDate, "YYYY-MM-DD").add(1, 'day') ;

            if(!this.tillDate){
                this.tillDate = moment(newDate).format("YYYY-MM-DD") ;
            }else if(moment(this.fromDate).format() > moment(this.tillDate).format()){
                this.tillDate = moment(newDate).format("YYYY-MM-DD") ;
            }

            //this.getLoggingData();
            
        },

        downloadData(Tag){

            this.$store.commit('app/setExportTag',Tag);
            
        },

    },
    watch: {

        
        loadingFinished: function () {

            // console.log("Selected Taggs");
            // console.log(tags);

            // if(this.loadingFinished){
            //     console.log("DONE");
            // }

            this.loadingFinished = false;


        },
        
    },
    
   
    created(){

        this.fromDate = moment().format("YYYY-MM-DD")
        this.tillDate = moment().add(1, 'day').format("YYYY-MM-DD")

        this.exportType = 'csv';

        //this.getLoggingData();
        
    },

    

    

}

</script>